import { Modal } from 'antd';
import React from 'react';

import { translate } from '@portal/services/i18n';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';

interface AcessDeniedModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const AccessDeniedModal = ({ setVisible, visible }: AcessDeniedModalProps) => {
  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal open={visible} footer={null} onCancel={handleCancel}>
      <div className="modal-access-danied">
        <h1 className="modal-access-danied__title">
          {translate('PAGES.MY_ACCOUNT.MULTI_ACCESS.DENIED_ACCESS.TITLE')}
        </h1>
        <p className="modal-access-danied__description">
          {translate('PAGES.MY_ACCOUNT.MULTI_ACCESS.DENIED_ACCESS.DESCRIPTION')}
        </p>
        <AdvancedButton
          text={translate('PAGES.MY_ACCOUNT.MULTI_ACCESS.DENIED_ACCESS.BUTTON')}
          onClick={handleCancel}
        />
      </div>
    </Modal>
  );
};

export default AccessDeniedModal;
